import { enforce, create, test, only } from "vest";

export default create((currentField, data = {}) => {
    only(currentField);

    test("tipo_cambio", "El tipo de cambio es requerido", () => {
        enforce(data.tipo_cambio).isNotEmpty();
    });
    test("tipo_cambio", "El tipo de cambio debe ser mayor a 0", () => {
        enforce(data.tipo_cambio).greaterThan(0);
    });
    test("condicion_pago_id", "La condición de pago es requerida", () => {
        enforce(data.condicion_pago_id).isNotEmpty();
    });
    test("ubicacion_id", "La ubicación es requerida", () => {
        enforce(data.ubicacion_id).isNotEmpty();
    });
});
